"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependentsEditHeader = DependentsEditHeader;
exports.DependentsEditForm = DependentsEditForm;
exports.default = DependentsEdit;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Helper_1 = require("../Helper");
const UserContext_1 = require("../contexts/UserContext");
const Field_1 = __importDefault(require("../components/Field"));
const Button_1 = __importDefault(require("../components/Button"));
const react_native_paper_1 = require("react-native-paper");
const react_native_mask_text_1 = require("react-native-mask-text");
const cancelable_promise_1 = require("cancelable-promise");
const Benefits_1 = __importDefault(require("../api/Benefits"));
const Loading_1 = __importDefault(require("../components/Loading"));
const react_i18next_1 = require("react-i18next");
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const SearchableDropdown_1 = __importDefault(require("../components/SearchableDropdown"));
const AuthForms_1 = require("../partials/AuthForms");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
function DependentsEditHeader(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: "row", justifyContent: "center", alignItems: "center" }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.PeopleGroup, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontWeight: "500", fontSize: size != 'sm' ? 18 : 16, marginLeft: 12 }, children: props.text }), !!props.subText && (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, marginLeft: 12 }, children: props.subText })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: "borderless", onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }));
}
function DependentsEditForm(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [status, setStatus] = react_1.default.useState("done");
    const [relationToInsuredError, setRelationToInsuredError] = react_1.default.useState(false);
    const [emailError, setEmailError] = react_1.default.useState(false);
    const [cityError, setCityError] = react_1.default.useState(false);
    const [zipError, setZipError] = react_1.default.useState(false);
    const [dependent, setDependent] = react_1.default.useState({
        relationType: '',
        relation: '',
        relationToInsured: '',
        beneficiaryIsATrust: false,
        spouse: false,
        firstName: '',
        middleInitial: '',
        lastName: '',
        gender: '',
        birthdate: '',
        ssn: '',
        tobaccoUser: false,
        isDisabled: false,
        fullTimeStudent: false,
        ftStudentCertDate: null,
        ftStudentCertExp: null,
        email: '',
        homePhone: '',
        workPhone: '',
        address: '',
        addressLine2: '',
        city: '',
        state: '',
        zip: ''
    });
    const relationTypes = [
        {
            label: t('myBenefits:text.typeD'),
            value: "D",
        },
        {
            label: t('myBenefits:text.typeB'),
            value: "B",
        },
    ];
    const internalRelations = [
        {
            label: t('myBenefits:text.spouse'),
            value: "spouse",
        },
        {
            label: t('myBenefits:text.dependent'),
            value: "dependent",
        },
        {
            label: t('myBenefits:text.husband'),
            value: "husband",
        },
        {
            label: t('myBenefits:text.son'),
            value: "son",
        },
        {
            label: t('myBenefits:text.daughter'),
            value: "daughter",
        }
    ];
    const externalRelations = [
        {
            label: t('myBenefits:text.spouse'),
            value: "spouse",
        },
        {
            label: t('myBenefits:text.child'),
            value: "child",
        },
        {
            label: t('myBenefits:text.other'),
            value: "other",
        },
        {
            label: t('myBenefits:text.domesticpartner'),
            value: "domesticpartner",
        },
        {
            label: t('myBenefits:text.disabledchild'),
            value: "disabledchild",
        }
    ];
    const genders = [
        {
            label: t('common:text.genM'),
            value: "M",
        },
        {
            label: t('common:text.genF'),
            value: "F",
        },
    ];
    const booleanOptions = [
        {
            label: t('common:text.yes'),
            value: "true",
        },
        {
            label: t('common:text.no'),
            value: "false",
        },
    ];
    const close = () => {
        promise.current?.cancel();
        props.onCancel();
    };
    const handleSave = react_1.default.useCallback(() => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'Edit Dependent/Beneficiary',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        setStatus("loading");
        promise.current?.cancel();
        // Enforce lowercase email
        dependent.email = dependent.email?.toLowerCase() ?? '';
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => Benefits_1.default.updateDependent(token, dependent)))
            .then((result) => {
            if (result == null) {
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('myBenefits:messages.depSaveFailed') });
            }
            else if (result.errorMessage.includes("city/state")) {
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('myBenefits:messages.depSaveFailed') + " " + t('myBenefits:messages.cityStateErr') });
            }
            else if (result.errorMessage.includes("required parameter")) {
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('myBenefits:messages.depSaveFailed') + " " + t('myBenefits:messages.missingReqErr') });
            }
            else {
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "success", message: t('myBenefits:messages.depSave') });
                react_native_1.DeviceEventEmitter.emit("event.dependentUpdate");
            }
        })
            .catch((e) => {
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('myBenefits:messages.depSaveFailed') });
        })
            .finally(() => {
            props.onSaved();
        });
    }, [dependent]);
    const refresh = react_1.default.useCallback(async () => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext
            .getToken()
            .then((token) => {
            Benefits_1.default.getDependent(token, props.dependentId).then((r) => {
                r.email = r?.email?.toLowerCase() ?? '';
                setDependent(r);
                setStatus('done');
                react_native_1.DeviceEventEmitter.emit("event.dependentLoaded", { name: `${r.firstName} ${r.middleInitial} ${r.lastName}`.replace(/\s+/g, ' ') });
            });
        })
            .catch(() => {
            setStatus('error');
        }));
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
            react_native_1.DeviceEventEmitter.removeAllListeners("event.dependentUpdate");
            react_native_1.DeviceEventEmitter.removeAllListeners("event.dependentLoaded");
        };
    }, [refresh]);
    // Check if an input field has a valid value
    const hasErrors = (field, value) => {
        switch (field) {
            case "city":
                if (value?.length == 0) {
                    return false;
                }
                else {
                    return !/^[A-Za-z\s]*$/.test(value) || !value || /^\s*$/.test(value) ? true : false;
                }
            case "email":
                if (value?.length == 0) {
                    return false;
                }
                else {
                    return !/^(\w|(\w+\+\w))+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/i.test(value) ? true : false;
                }
            case "text":
                return !value || /^\s*$/.test(value) ? true : false;
            case "zipCode":
                if (value?.length == 0) {
                    return false;
                }
                else {
                    return value?.length != 5 || value?.match(/^[0-9]+$/) == null ? true : false;
                }
        }
    };
    // Check if form can be submitted
    const formHasErrors = () => {
        return (relationToInsuredError ||
            emailError ||
            cityError ||
            zipError);
    };
    const handleToggleSSN = props.onToggleSSN;
    return ((status == "done" && ((0, jsx_runtime_1.jsxs)(FadeInView_1.default, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myBenefits:labels.relType'), value: relationTypes.find(x => x.value == dependent?.relationType)?.label ?? "—" }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: dependent?.relationType == "D" &&
                            (0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myBenefits:labels.rel'), value: userContext?.isInternal == true ? internalRelations.find(x => x.value == dependent?.relation)?.label ?? t('myBenefits:text.other') : externalRelations.find(x => x.value == dependent?.relation)?.label ?? t('myBenefits:text.other') }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myBenefits:labels.bDate'), value: dependent.birthdate ? new Date(dependent.birthdate).toLocaleDateString(Helper_1.Helper.deviceLanguage(), { month: 'short', year: 'numeric', day: 'numeric', timeZone: 'UTC' }) : "—" }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('common:labels.ssn'), value: props.showSSN ? (dependent.ssn || '—') : '*********' }) }), (0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: handleToggleSSN, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: props.showSSN ? Theme_1.ICONS.Regular.EyeSlash : Theme_1.ICONS.Regular.Eye, size: 20, color: THEME.SmokeWhiteText }) })] })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator, { marginVertical: 12 }] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: genders, label: t('myBenefits:labels.gender'), setValue: (value) => {
                                props.onIsChanged();
                                setDependent({
                                    ...dependent,
                                    gender: value,
                                });
                            }, value: dependent.gender }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.email'), dense: true, error: emailError, label: t('common:labels.email'), mode: "outlined", onChangeText: (value) => {
                                    props.onIsChanged();
                                    setDependent({
                                        ...dependent,
                                        email: value,
                                    });
                                    setEmailError(hasErrors("email", value));
                                }, style: STYLES.input, value: dependent.email, maxLength: 50 }), emailError && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: emailError ? t('common:messages.emailHelp') : '' })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.hPhone'), dense: true, inputMode: "tel", label: t('common:labels.hPhone'), maxLength: 14, mode: 'outlined', style: STYLES.input, value: dependent.homePhone, render: (inputProps) => ((0, jsx_runtime_1.jsx)(react_native_mask_text_1.MaskedTextInput, { ...(() => { var { value, ...p } = inputProps; return p; })(), defaultValue: dependent.homePhone, mask: '(999) 999-9999', onChangeText: (formatted, extracted) => {
                                    props.onIsChanged();
                                    setDependent({
                                        ...dependent,
                                        homePhone: extracted,
                                    });
                                } })) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.wPhone'), dense: true, inputMode: 'tel', label: t('common:labels.wPhone'), maxLength: 14, mode: 'outlined', style: STYLES.input, value: dependent.workPhone, render: (inputProps) => ((0, jsx_runtime_1.jsx)(react_native_mask_text_1.MaskedTextInput, { ...(() => { var { value, ...p } = inputProps; return p; })(), defaultValue: dependent.workPhone, mask: '(999) 999-9999', onChangeText: (formatted, extracted) => {
                                    props.onIsChanged();
                                    setDependent({
                                        ...dependent,
                                        workPhone: extracted,
                                    });
                                } })) }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.address1'), dense: true, label: t('common:labels.address1'), mode: "outlined", onChangeText: (value) => {
                                props.onIsChanged();
                                setDependent({
                                    ...dependent,
                                    address: value,
                                });
                            }, style: STYLES.input, value: dependent.address }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.address2'), dense: true, label: t('common:labels.address2'), mode: "outlined", onChangeText: (value) => {
                                props.onIsChanged();
                                setDependent({
                                    ...dependent,
                                    addressLine2: value,
                                });
                            }, style: STYLES.input, value: dependent.addressLine2 }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.city'), dense: true, error: cityError, label: t('common:labels.city'), mode: "outlined", onChangeText: (value) => {
                                    props.onIsChanged();
                                    setDependent({
                                        ...dependent,
                                        city: value,
                                    });
                                    setCityError(hasErrors("city", value));
                                }, style: STYLES.input, value: dependent.city }), cityError &&
                                (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { accessibilityLiveRegion: 'assertive', type: "error", visible: cityError, children: cityError ? t('common:messages.cityHelp') : '' })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: Helper_1.Helper.dropdownStateAbbr, label: t('common:labels.state'), setValue: (value) => {
                                props.onIsChanged();
                                setDependent({
                                    ...dependent,
                                    state: value,
                                });
                            }, value: dependent.state }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.zip'), dense: true, error: zipError, inputMode: "numeric", label: t('common:labels.zip'), maxLength: 5, mode: "outlined", onChangeText: (value) => {
                                    props.onIsChanged();
                                    setDependent({
                                        ...dependent,
                                        zip: value,
                                    });
                                    setZipError(hasErrors("zipCode", value));
                                }, style: STYLES.input, value: dependent.zip }), zipError &&
                                (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { accessibilityLiveRegion: 'assertive', type: "error", visible: zipError, children: zipError ? t('common:messages.zipHelp') : '' })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: booleanOptions, label: t('myBenefits:labels.ftStu'), setValue: (value) => {
                                props.onIsChanged();
                                setDependent({
                                    ...dependent,
                                    fullTimeStudent: value == "true",
                                });
                            }, value: dependent.fullTimeStudent ? "true" : "false" }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: booleanOptions, label: t('myBenefits:labels.tobacco'), setValue: (value) => {
                                props.onIsChanged();
                                setDependent({
                                    ...dependent,
                                    tobaccoUser: value == "true",
                                });
                            }, value: dependent.tobaccoUser ? "true" : "false" }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: booleanOptions, label: t('myBenefits:labels.disabled'), setValue: (value) => {
                                props.onIsChanged();
                                setDependent({
                                    ...dependent,
                                    isDisabled: value == "true",
                                });
                            }, value: dependent.isDisabled ? "true" : "false" }) })] }), dependent.relationType == "B" &&
                (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('myBenefits:labels.relIns'), dense: true, error: relationToInsuredError, label: t('myBenefits:labels.relIns'), mode: "outlined", onChangeText: (value) => {
                                        props.onIsChanged();
                                        setDependent({
                                            ...dependent,
                                            relationToInsured: value,
                                        });
                                        setRelationToInsuredError(hasErrors("text", value));
                                    }, style: STYLES.input, value: dependent.relationToInsured }), relationToInsuredError &&
                                    (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { accessibilityLiveRegion: 'assertive', type: "error", visible: relationToInsuredError, children: relationToInsuredError ? t('myBenefits:messages.relInsHelp') : '' })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: booleanOptions, label: t('myBenefits:labels.benIsTrust'), setValue: (value) => {
                                    props.onIsChanged();
                                    setDependent({
                                        ...dependent,
                                        beneficiaryIsATrust: value === "true",
                                    });
                                }, value: dependent.beneficiaryIsATrust }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: "row", marginTop: 6, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", text: t('common:buttons.cancel'), onPress: close }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: formHasErrors(), text: t('common:buttons.save'), onPress: handleSave }) })] })] }))) || (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == "loading", error: status == "error", onRetry: () => handleSave() }));
}
function DependentsEdit(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const [name, setName] = react_1.default.useState("");
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [isChanged, setIsChanged] = react_1.default.useState(false);
    const [isConfirming, setIsConfirming] = react_1.default.useState(false);
    const [step, setStep] = react_1.default.useState('editing');
    const [showSSN, setShowSSN] = react_1.default.useState(false);
    react_native_1.DeviceEventEmitter.addListener("event.dependentLoaded", (eventData) => onDependentLoaded(eventData));
    const onDependentLoaded = (result) => {
        setName(result?.name ?? "");
    };
    const onClose = () => {
        if (isChanged) {
            setIsConfirming(true);
        }
        else {
            if (props.onClose)
                props.onClose();
            else
                props.navigation.goBack();
        }
    };
    react_1.default.useEffect(() => {
        return () => react_native_1.DeviceEventEmitter.removeAllListeners("event.dependentLoaded");
    }, []);
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, needsConfirmation: isChanged, onConfirmation: () => step === 'authenticate' ? (setIsConfirming(false), setStep('editing')) : setIsConfirming(true), children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 8, paddingBottom: 2 }, children: (0, jsx_runtime_1.jsx)(DependentsEditHeader, { text: t('myBenefits:text.depEdit'), subText: name, onClose: onClose }) }), (0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, { contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, keyboardShouldPersistTaps: 'handled', children: [isConfirming &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { display: step === 'authenticate' ? 'none' : undefined }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginBottom: 12, backgroundColor: THEME.UltraLightGray, borderRadius: 4, flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 6, borderBottomLeftRadius: 4, borderTopLeftRadius: 4, backgroundColor: THEME.Red } }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 12, flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, fontWeight: '500', paddingVertical: 1 }, children: t('common:text.sure') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, paddingVertical: 1 }, children: t('common:text.sureDescription') })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6, marginBottom: size != 'sm' ? 0 : 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'outline', text: t('common:buttons.back'), onPress: () => { setIsConfirming(false); } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('common:buttons.discard'), onPress: () => props.navigation.goBack() }) })] })] }), (step === 'authenticate') &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { display: isConfirming ? 'none' : undefined }, children: (0, jsx_runtime_1.jsx)(AuthForms_1.AuthReauthenticate, { onCancel: () => setStep('editing'), onSuccess: () => {
                                    setStep('editing');
                                    setShowSSN(true);
                                } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [(step !== 'editing' || isConfirming) && { display: 'none' }], children: (0, jsx_runtime_1.jsx)(DependentsEditForm, { dependentId: props.route.params.dependentId, onCancel: onClose, onSaved: props.onSave ?? props.navigation.goBack, onIsChanged: () => setIsChanged(true), showSSN: showSSN, onToggleSSN: () => {
                                if (!showSSN) {
                                    setStep('authenticate');
                                }
                                else {
                                    setShowSSN(false);
                                }
                            } }) })] })] }));
}
